var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticClass: "form-control",
    attrs: {
      placeholder: _vm.resource(
        "JourneyBuilder_JourneyDropdown_PlaceholderText"
      ),
      label: "name",
      options: _vm.journeys,
      clearable: "",
      searchable: "",
      filterable: ""
    },
    model: {
      value: _vm.selectedJourney,
      callback: function($$v) {
        _vm.selectedJourney = $$v
      },
      expression: "selectedJourney"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }